export default __webpack_public_path__ + "locales/vi/DeleteThirdPartyDialog.json?hash=a3a12a2bbcad8088c628c8bb29a7a03b";